export * from './TeamBlock';

import { TeamBlock } from './TeamBlock';

export default TeamBlock;
